// extracted by mini-css-extract-plugin
export default {"snackbar":"styles_snackbar__75XhD","error":"styles_error__d8-pm","message":"styles_message__wN7Gx","close":"styles_close__cxBxH"};